import * as React from 'react';

/**
 * @description InvestmentLifeInsurance icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { InvestmentLifeInsurance } from '@sravni/design-system-icons'
 *
 * <InvestmentLifeInsurance />
 * ```
 */
const InvestmentLifeInsurance = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "InvestmentLifeInsurance", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M18.736 9.418c0 4.894-3.413 9.47-8 10.582-4.587-1.111-8-5.688-8-10.582V5.573c0-.875.491-1.664 1.243-1.995l5-2.205a4.328 4.328 0 0 1 3.514 0l5 2.205c.752.332 1.243 1.12 1.243 1.995v3.845Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m13.236 7.5 2.246-.5.254 2", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m6.236 13 1.352-1.701a.827.827 0 0 1 1.088-.205l1.933 1.213c.353.222.84.13 1.088-.204L15.482 7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { InvestmentLifeInsurance };
//# sourceMappingURL=InvestmentLifeInsurance.js.map
